import React from 'react';

import Skeleton from 'components/Skeleton';

const GuidesSkeleton = () => {
    const purchasedGuides = Array.from({ length: 3 }, (_, i) => <Skeleton key={i} height={88} mb={12} />);
    const freeGuides = Array.from({ length: 5 }, (_, i) => <Skeleton key={i} height={88} mb={12} />);

    return (
        <>
            <Skeleton width={100} height={13} />
            {purchasedGuides}
            <Skeleton width={100} height={13} />
            {freeGuides}
        </>
    );
};

export default GuidesSkeleton;
